export const PauseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      clipPath="url(#clip0_19723_14812)"
    >
      <path d="M8.333 13.334V6.667M11.667 6.667v6.667M10 17.5a7.5 7.5 0 0 0 7.5-7.5A7.5 7.5 0 0 0 10 2.5 7.5 7.5 0 0 0 2.5 10a7.5 7.5 0 0 0 7.5 7.5"></path>
    </g>
    <defs>
      <clipPath id="clip0_19723_14812">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
